/*******************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 *******************************************************************************/
'use strict';

var Promise = require('bluebird'),
  xhr = require('./xhr');

// @resolves With an object having `body`, `xhr` properties
// @rejects With an Error having `body`, `xhr` properties
module.exports = function (url, options) {
  return new Promise(function (resolve, reject) {
    xhr(url, options, function (error, body, xhr) {
      if (error) {
        error.body = body;
        error.xhr = xhr;
        reject(error);
        return;
      }
      resolve({
        xhr: xhr,
        body: body
      });
    });
  });
};